module.exports = __webpack_public_path__ + "static/slide-6-0ca35d7a748d5497e5422f0667790ba7.png";